import { type StoneAccountsResponse } from '../entities'
import { type Entity, type Kyc, type OptIns, type OriginBrand, type Person, type Subject } from '../types'

import { parseAccountList } from './session-web-parser'

type SelectedAccount = StoneAccountsResponse['stoneAccounts'][number]
type Session = { subject: Subject<OptIns>; entity: Entity<OptIns> }

const restoreLegacyPersonFields = (people: Person[], legacyPeople: Person[]): Person[] =>
  people.map(person => {
    const legacyPerson = legacyPeople.find(({ id }) => id === person.id)
    if (!legacyPerson) return person
    return {
      ...person,
      roles: legacyPerson.roles,
      approvalStatus: legacyPerson.approvalStatus,
      unsafe: legacyPerson.unsafe
    }
  })

export const mergeUnifiedAccounts = (
  legacy: Session,
  { stoneAccounts }: StoneAccountsResponse,
  selectedAccount?: SelectedAccount
): Session => {
  const { organizations, users } = parseAccountList(stoneAccounts)

  const restoredOrganizations = restoreLegacyPersonFields(organizations, legacy.subject.organizations)
  const restoredUsers = restoreLegacyPersonFields(users, legacy.subject.users)

  const subject: Subject<OptIns> = {
    ...legacy.subject,
    organizations: restoredOrganizations,
    users: restoredUsers,
    stoneAccounts: [...restoredOrganizations, ...restoredUsers]
  }

  if (!selectedAccount) return { subject, entity: legacy.entity }

  if (legacy.entity.id !== selectedAccount.legacy.globalId) {
    throw new Error('Conta selecionada não encontrada na fonte legada')
  }

  const entity: Entity<OptIns> = {
    ...legacy.entity,
    stoneAccount: {
      id: selectedAccount.id,
      situation: selectedAccount.situation,
      originBrand: selectedAccount.originBrand as OriginBrand,
      paymentProfiles: selectedAccount.paymentProfiles ?? [],
      ...(selectedAccount.kyc ? { kyc: selectedAccount.kyc as Kyc } : {})
    }
  }

  return { subject, entity }
}
